<div class="flex flex-col gap-3 md:gap-4" [formGroup]="formGroup">
    <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
        {{ 'iro.deal-type.select' | translate }}
    </h2>
    <p class="text-sm text-shui-text-moderate m-0 p-0">
        {{ 'iro.deal-type.select-description' | translate }}
    </p>
    <sh-radio-card class="block mt-4" formControlName="dealType">
        <sh-radio-card-item [value]="DealType.INSTRUMENT_ONLY">
            <div class="flex flex-col gap-4">
                <p class="text-base text-shui-text-strong m-0 p-0 font-semibold">
                    {{ 'iro.deal-type.instrument-only' | translate }}
                </p>
                <p class="text-sm text-shui-text-strong m-0 p-0">
                    {{ 'iro.deal-type.instrument-only-description' | translate }}
                </p>
                <ul class="m-0 p-0 pl-6">
                    <li class="text-sm text-shui-text-strong">
                        {{ 'iro.deal-type.instrument-only-feature-1' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'iro.deal-type.instrument-only-feature-2' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'iro.deal-type.instrument-only-feature-3' | translate }}
                    </li>
                </ul>
            </div>
        </sh-radio-card-item>
        <sh-radio-card-item [value]="DealType.STANDARD_DEAL">
            <div class="flex flex-col gap-4">
                <p class="text-base text-shui-text-strong m-0 p-0 font-semibold">
                    {{ 'iro.deal-type.standard-deal' | translate }}
                </p>
                <p class="text-sm text-shui-text-strong m-0 p-0">
                    {{ 'iro.deal-type.standard-deal-description' | translate }}
                </p>
                <ul class="m-0 p-0 pl-6">
                    <li class="text-sm text-shui-text-strong">
                        {{ 'iro.deal-type.standard-deal-feature-1' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'iro.deal-type.standard-deal-feature-2' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'iro.deal-type.standard-deal-feature-3' | translate }}
                    </li>
                </ul>
            </div>
        </sh-radio-card-item>
    </sh-radio-card>
</div>
